import { WebMercatorViewport, LinearInterpolator } from "@deck.gl/core";

export default function fitBounds(bounds, width, height) {
  if (!width || !height) return;

  let padding: number;
  if (window.innerWidth > 1600) {
    padding = 250;
  } else if (window.innerWidth <= 1600 && window.innerWidth > 768) {
    padding = 150;
  } else {
    padding = 50;
  }

  //Compensate for the toolbars at the bottom of the map
  if (window.innerWidth >= 1024) {
    height -= 120;
  } else if(window.innerWidth >= 800) {
    height -= 60;
  }

  const { minLng, minLat, maxLng, maxLat } = bounds;
  const viewport = new WebMercatorViewport({ width, height });
  const { longitude, latitude, zoom } = viewport.fitBounds(
    [
      [minLng, minLat],
      [maxLng, maxLat]
    ],
    {
      padding
    }
  );

  //Adjust the zoom to ensure countries don't get cut off too much
  const adjustedZoom = zoom * 0.9;

  return { longitude, latitude, zoom: adjustedZoom, transitionDuration: 1000, transitionInterpolator: new LinearInterpolator() };
}